import { CompatibilityService } from '@common/services/compatibilityservice';
import { AsObservableArray, NavGridOptions, constants, ReplaceObservableData, SaveAsExcel, INavGrid, GetGridOptionSettings, IInfNotification, GetGridDataSource, BindGridCustomizations } from '@common/navkendo';
import { IObservableArray, Observable, IPageProperty, NavGridVisibility, IPageMetaData } from '@common/nav';
import { fn, IInfOperation } from '@common/utils';
import { SearchInputs } from '../navkendo';
import { FwfDataService } from '@common/rwf/fwfdata.service';
import { InfUserSettingsAccess } from '@common/services/settingsservice';
import { GetCustomKendoTemplate } from '../kendo/templates';
import { kendoColumn, INavPageClientInfo } from '@common/navdata';
import { OpenDocInfo } from '../CtrWFInstanceAddOnData';
import { IWorkflow_FWF_Instance_Completed, IWorkflow_FWF_Types } from '@common/rwf';
import { IRoutingService } from '@common/services/autoresolveservice';

const Suchergebnisse = 'Suchergebnisse';
const fwfsearch = "fwfsearch";
const fwftype = "fwftype";
export class FWFSearchCtrl extends Observable {
    static Directive = [() => <ng.IDirective>{
        template: require('./fwfsearch.fragment.html'),
        controller: FWFSearchCtrl,
        controllerAs: "vm",
    }];
    static $inject = ["$scope", "CompatibilityService", "Routing", "FwfDataService"];
    constructor($scope: ng.IScope, private readonly $c: CompatibilityService,
        readonly $routing: IRoutingService,
        private readonly fwfData: FwfDataService) {
        super();
        const ctrl = this;
        this.PGM = $c.resolve("NavClient").GetPageClientInfo("Workflow_FWF_Instance_Completed").then(s => {
            this.EnsureGridOptions(s.MetaData, []);
            return s;
        }, err => { alert(fn.resolveToError(err)); throw err; });
        this.StartExecuteSearch = fn.proxy(this.StartExecuteSearch, this);
        this.Search = {
            Execute: this.StartExecuteSearch,
            Enabled: false
        }
        this.ExcelExport = {
            Execute: () => SaveAsExcel([{ Grid: this.grdFwfSearchResult }]),
            get Enabled() { return ctrl.Items.length > 0; }
        }
        this.SearchInputs.AppendSearchInput();
        this.fwfData.GetFWFAdditionalTypes().then(
            fwfTypes => {
                this.FWFTypes = AsObservableArray(fwfTypes)
                const initType = $routing.Search(fwftype);
                if (initType) {
                    this.SetSelectedType(initType);
                }
            },
            err => alert(fn.resolveToError(err))
        );

        // Refresh on Route Change
        $scope.$on("$destroy", <any>$scope.$on("$routeUpdate", (e, route: ng.route.ICurrentRoute) => {
            const params = route?.params;
            const currView = params?.view;
            const currSearch = params?.fwftype;
            const selectedId = this.SelectedType?.ID;
            if (currView === fwfsearch && selectedId && currSearch != selectedId) {
                $routing.search(fwftype, selectedId);
            } else if (currView != fwfsearch && currSearch) {
                $routing.search(fwftype, null);
                this.currentGridUserSettings?.Save();
            }
        }));

        $scope.$on("$destroy", () => this.currentGridUserSettings?.Save());
    }

    StartExecuteSearch() {
        // Show search result panel after first search
        $('#fwfsearchResults').fadeIn();
        const searchErrors = this.searchErrors;
        searchErrors?.RemoveNotifications();

        return this.PGM.then(pgm => {
            const maxCount = 200;
            return this.fwfData.QueryFWFInstancesCompleted(this.SelectedType?.ID, maxCount, this.SearchInputs.GetAsConstraints(pgm.MetaData)).then(result => {
                ReplaceObservableData(this.Items, result.Data, t => t.Key);
                
                this.ResultInfo = Suchergebnisse + " (" + (result.Bookmark.AllRead ? "" : ">") + result.Data.length + ")";
                if(!result.Bookmark.AllRead) {
                    searchErrors?.AddNotification({
                        messageType: "warning",
                        message: "Nur die ersten " + maxCount + " Treffer werden aus Performancegründen angezeigt"
                        });
                }
            }).then(fn.noop, err => {
                searchErrors?.AddNotification({
                    messageType: "error",
                    message: fn.resolveToError(err)
                });
            });
        });
    }

    SetSelectedType(item: IWorkflow_FWF_Types | string, config?: {}) {
        const $c = this.$c;
        const fwfData = this.fwfData;
        const selectedTypeId = (typeof (item) === "string" ? item : item?.ID) || "";
        this.Search.Enabled = !!selectedTypeId;
        if (!selectedTypeId) {
            delete this.SelectedType;
            ReplaceObservableData(this.Items, [], t => t.Key);
            this.SearchInputs.SetAvailableProperties([]);
            return $c.when();
        } else {
            $('#fwfsearchResults').fadeIn();
            const searchErrors = this.searchErrors;
            searchErrors?.RemoveNotifications();
            ReplaceObservableData(this.Items, [], t => t.Key);
            this.ResultInfo = Suchergebnisse;
            this.searchErrors?.RemoveNotifications();
            const persistKey = ["KWF", "FWFSearchCtrl", selectedTypeId];
            var currentGridUserSettings = this.currentGridUserSettings;
            if (!currentGridUserSettings) {
                this.currentGridUserSettings = currentGridUserSettings = $c.resolve("NavSettings").CreateUserSettings(persistKey);
                currentGridUserSettings.Add("Grid", GetGridOptionSettings(this.GridOptions, () => this.grdFwfSearchResult));
            } else {
                currentGridUserSettings.Save();
                currentGridUserSettings.RefreshPersistKey(persistKey, false);
            }

            delete this.SelectedType;
            fwfData.GetFWFAdditionalProperties(selectedTypeId).then(fwfProperties => {
                return this.PGM.then(pgm => {
                    const getSord = (p: IPageProperty) => (p.Title || p.Name)?.toLocaleLowerCase();
                    var baseSortProps = pgm.MetaData.Properties.filter(item => item.Name != "FWFData" && item.Name != "TypeID");
                    const sortedProps = fn.FlattenArray([baseSortProps, fwfProperties]);
                    sortedProps.sort((a, b) => getSord(a).localeCompare(getSord(b)))
                    this.SearchInputs.SetAvailableProperties(sortedProps);
                })
            });
            var pendingQueryCols = this.pendingQueryCols = fwfData.GetFWFAdditionalColumns(selectedTypeId).then(cols => {
                // only if not via user settings!
                if (!fn.FindFirst(cols, c => !c.hidden)) {
                    cols.forEach(c => c.hidden = false);
                }
                this.trigger("applyCols");
                this.one("applyCols", this.grdFwfSearchResult?.addDynamicColumns(0, cols));
                $c.finally(currentGridUserSettings.Load(), () => {

                    return this.PGM.then(pgm => {
                        // TODO we must forced apply if no usersettings available ....
                        const colInfo = (this.grdFwfSearchResult?.columns || []).map(item => item.field).join("");

                        const InitVisibleColInfo = pgm.MetaData.Properties.filter(item => item.InitialVisible !== false).map(item => item.Name).join("");
                        if (colInfo == InitVisibleColInfo) {
                            this.grdFwfSearchResult.reCreate(o => {
                                o.columns.splice(2, 0, ...cols);
                                this.one("applyCols", () => {
                                    cols.forEach(item => {
                                        var idx = o.columns.indexOf(item);
                                        if (idx >= 0) {
                                            o.columns.splice(idx, 1);
                                        }
                                    })
                                    var names = cols.map(item => item.field)
                                    cols = this.grdFwfSearchResult.columns.filter(item => names.indexOf(item.field) >= 0);
                                    cols.forEach(item => {
                                        var idx = this.grdFwfSearchResult.columns.indexOf(item);
                                        if (idx >= 0) {
                                            this.grdFwfSearchResult.columns.splice(idx, 1);

                                        }
                                    });
                                });
                                return o;
                            })
                        }
                    });
                });
                this.SelectedType = fn.FindFirst(this.FWFTypes, "ID", selectedTypeId);
                this.$routing.search(fwftype, selectedTypeId);
            }).then(fn.noop, err => {
                if (searchErrors) {
                    searchErrors?.RemoveNotifications();
                    searchErrors.AddNotification({ message: fn.resolveToError(err), messageType: "error" });
                } else {
                    throw err;
                }
            }).then(fn.noop, fn.noop).then(() => {
                if (pendingQueryCols == this.pendingQueryCols) {
                    delete this.pendingQueryCols;
                }
            });
            return pendingQueryCols;
        }
    }

    pendingQueryCols: PromiseLike<any>;
    currentGridUserSettings: InfUserSettingsAccess
    get grdFwfSearchResult(): INavGrid {
        return this.__grd
    }
    set grdFwfSearchResult(value: INavGrid) {
        if (this.__grd = value) {
            this.currentGridUserSettings?.Load();
            BindGridCustomizations(value, {
                RowCustomizations: [{
                    Id: 'fwf_missingdata',
                    BackColor: "red",
                    Description: "Die typspezifischen Daten für diesen Beleg konnten nicht (vollständig) bestimmt werden!",
                    Condition: [{ field: "_MissingData", operator: "isnotnull" }],
                }],
            });
        }
    }
    private __grd: INavGrid;
    private readonly PGM: PromiseLike<INavPageClientInfo<IWorkflow_FWF_Instance_Completed, string>>
    ResultInfo = Suchergebnisse;
    readonly Search: IInfOperation;
    readonly ExcelExport: IInfOperation;
    FWFTypes: IObservableArray<IWorkflow_FWF_Types>;
    SelectedType: IWorkflow_FWF_Types;
    SearchInputs = new SearchInputs();
    GridOptions: NavGridOptions;
    readonly Items = AsObservableArray<IWorkflow_FWF_Instance_Completed & { _MissingData?: any }>([])
    searchErrors: IInfNotification;
    EnsureGridOptions(pgm: IPageMetaData<IWorkflow_FWF_Instance_Completed>, addCols: kendo.ui.GridColumn[]) {
        if (this.GridOptions) {
            return this.GridOptions;
        }
        const docCol: Partial<kendo.ui.GridColumn> =
        {
            width: constants.KendoGrid_PreviewIconColumnSize,
            template: GetCustomKendoTemplate("DataGridNavSearchPreviewButtonTemplate")
        };
        var colInfo = <kendo.ui.GridColumn>{
            title: "", width: constants.KendoGrid_ActionIconColumnSize, filterable: false,
            command: [{
                attr: { title: "Belegauskunft anzeigen" },
                name: "openJournal", text: "", className: "idms_DataGridButton",
                click: (event) => OpenDocInfo(event),
                template: "<a class='k-grid-openJournal'><span class='idms_Image16 idms_Image_Info16 idms_HoverImage' title='Belegauskunft anzeigen'></span></a>"
            }]
        };
        return this.GridOptions = <NavGridOptions>{
            columns: fn.FlattenArray([[docCol, colInfo], pgm.Properties.filter(item => item.GridVisibility != NavGridVisibility.ForcedRemove).map(c => kendoColumn(c)), addCols]),
            dataSource: GetGridDataSource(this.Items, pgm.Model),
            selectable: true, //"multiple": no text selection
            resizable: true, // performance loss: ~18%
            reorderable: true, // performance loss: ~0%
            sortable: {}, // performance loss: ~5%
            groupable: { messages: { empty: "Ziehen Sie eine Spaltenüberschrift hierher, um Belege nach dieser Spalte zu gruppieren!" } }, // performance loss: ~9%
            pageable: {
                pageSize: constants.DefaultPaging,
                pageSizes: constants.DefaultPagings,
                messages: {
                    display: "Anzeigen der Belege {0} - {1} von {2}",
                    empty: "Keine Belege zum Anzeigen",
                    itemsPerPage: "Belege pro Seite"
                }
            },
            columnMenu: { filterable: false }, // performance loss: ~50%
            excel: {
                allPages: true
            },
            navigatable: true, // Use arrow keys to navigate on grid (functionality added)

            // Custom added options
            groupingDescription: "Belege gruppiert nach:",
            storeGroupingState: { key: "EntryNo" },
            dblClick: (event) => OpenDocInfo(<any>event.event)
        };
    }
}
